/* Vi besøger — henter /apps/portal/cardshows (App Proxy, ingen auth) og
   renderer kommende shows (store event-kort m. dato-blok) + tidligere shows
   (kompakt grid). Det NÆSTE show fremhæves m. badge og countdown.
   Datoer formateres på dansk uden libraries. Fail-soft ved fejl. ES5. */
(function () {
  'use strict';

  var rod = document.querySelector('[data-mtw-cardshows]');
  if (!rod) return;

  var kommendeEl = rod.querySelector('[data-mtw-cs-kommende]');
  var tidligereSektion = rod.querySelector('[data-mtw-cs-tidligere-sektion]');
  var tidligereEl = rod.querySelector('[data-mtw-cs-tidligere]');
  if (!kommendeEl) return;

  var MDR = ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];
  var UGEDAGE = ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag'];
  var UGEDAGE_KORT = ['søn', 'man', 'tir', 'ons', 'tor', 'fre', 'lør'];

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Kun http(s)-URL'er slipper igennem til src/href-attributter */
  function sikkerUrl(u) {
    if (typeof u !== 'string') return '';
    if (u.indexOf('https://') === 0 || u.indexOf('http://') === 0) return esc(u);
    return '';
  }

  function parseDato(iso) {
    if (!iso) return null;
    var d = new Date(iso);
    return isNaN(d.getTime()) ? null : d;
  }

  function pad2(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function klokke(d) {
    return pad2(d.getHours()) + '.' + pad2(d.getMinutes());
  }

  /* Midnat lokal tid — bruges til dags-diff (countdown + flerdages-tjek) */
  function midnat(d) {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  }

  var PIN_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 21.5s-6.5-6.1-6.5-11a6.5 6.5 0 0 1 13 0c0 4.9-6.5 11-6.5 11z" fill="#FFCB03" stroke="#1a1a1a" stroke-width="2" stroke-linejoin="round"/><circle cx="12" cy="10.3" r="2.4" fill="#fffdf5" stroke="#1a1a1a" stroke-width="2"/></svg>';
  var UR_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="8.5" fill="#fffdf5" stroke="#1a1a1a" stroke-width="2"/><path d="M12 7.5V12l3 2.2" fill="none" stroke="#1a1a1a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="12" cy="12" r="1.3" fill="#FFCB03" stroke="#1a1a1a" stroke-width="1"/></svg>';
  var PIL_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4.5 12h14M13 6.5l5.5 5.5-5.5 5.5" fill="none" stroke="#1a1a1a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var FLAG_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 21.5V3.5" fill="none" stroke="#1a1a1a" stroke-width="2" stroke-linecap="round"/><path d="M6 4.5h11.5l-2.6 3.7 2.6 3.7H6z" fill="#fffdf5" stroke="#1a1a1a" stroke-width="2" stroke-linejoin="round"/></svg>';
  var KAL_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="3.5" y="5" width="17" height="15.5" rx="2.5" fill="#fffdf5" stroke="#1a1a1a" stroke-width="2"/><path d="M3.5 9.5h17" stroke="#1a1a1a" stroke-width="2"/><path d="M8 2.8v3.4M16 2.8v3.4" stroke="#1a1a1a" stroke-width="2" stroke-linecap="round"/><rect x="7" y="12.5" width="4" height="4" rx="1" fill="#FFCB03" stroke="#1a1a1a" stroke-width="1.5"/></svg>';

  function datoBlok(start, slut) {
    var flereDage = slut && midnat(slut) > midnat(start);
    var dag;
    var mdr;
    var ugedag;
    if (flereDage) {
      if (start.getMonth() === slut.getMonth()) {
        dag = start.getDate() + '.–' + slut.getDate() + '.';
        mdr = MDR[start.getMonth()];
      } else {
        dag = start.getDate() + '. ' + MDR[start.getMonth()] + '–' + slut.getDate() + '.';
        mdr = MDR[slut.getMonth()];
      }
      ugedag = UGEDAGE_KORT[start.getDay()] + '–' + UGEDAGE_KORT[slut.getDay()];
    } else {
      dag = String(start.getDate());
      mdr = MDR[start.getMonth()];
      ugedag = UGEDAGE[start.getDay()];
    }
    return (
      '<div class="mtw-cs__dato' + (flereDage ? ' mtw-cs__dato--flere' : '') + '" aria-hidden="true">' +
      '<span class="mtw-cs__dato-dag">' + esc(dag) + '</span>' +
      '<span class="mtw-cs__dato-mdr">' + esc(mdr) + '</span>' +
      '<span class="mtw-cs__dato-ugedag">' + esc(ugedag) + '</span>' +
      '</div>'
    );
  }

  function nedtaelling(start) {
    var dage = Math.round((midnat(start) - midnat(new Date())) / 86400000);
    if (dage <= 0) return 'i dag!';
    if (dage === 1) return 'i morgen';
    return 'om ' + dage + ' dage';
  }

  function renderShow(show, erNaeste) {
    var start = parseDato(show.start);
    var slut = parseDato(show.slut);
    if (!start) return '';

    var billede = sikkerUrl(show.billede);
    var link = sikkerUrl(show.link);

    var html = '<article class="mtw-cs__show' + (erNaeste ? ' mtw-cs__show--naeste' : '') + '">';
    if (erNaeste) {
      html += '<span class="mtw-cs__naeste-badge">' + FLAG_SVG + ' Næste stop</span>';
    }
    html += datoBlok(start, slut);
    html += '<div class="mtw-cs__info">';
    html += '<h3 class="mtw-cs__navn">' + esc(show.navn || 'Cardshow') + '</h3>';
    if (erNaeste) {
      html += '<div><span class="mtw-cs__nedtaelling">Vi ses ' + esc(nedtaelling(start)) + '</span></div>';
    }

    html += '<div class="mtw-cs__meta">';
    if (show.sted || show.by) {
      html += '<span class="mtw-cs__meta-rk">' + PIN_SVG + ' <span>';
      if (show.sted) html += '<b>' + esc(show.sted) + '</b>';
      if (show.sted && show.by) html += ', ';
      if (show.by) html += esc(show.by);
      html += '</span></span>';
    }
    if (slut) {
      html += '<span class="mtw-cs__meta-rk">' + UR_SVG + ' <span>' + klokke(start) + '–' + klokke(slut) + '</span></span>';
    } else {
      html += '<span class="mtw-cs__meta-rk">' + UR_SVG + ' <span>fra ' + klokke(start) + '</span></span>';
    }
    html += '</div>';

    if (show.adresse) html += '<span class="mtw-cs__adresse">' + esc(show.adresse) + '</span>';
    if (show.beskrivelse) html += '<p class="mtw-cs__besk">' + esc(show.beskrivelse) + '</p>';
    if (billede) {
      html += '<img class="mtw-cs__billede" src="' + billede + '" alt="' + esc(show.navn || '') + '" decoding="async" onerror="this.parentNode.removeChild(this)">';
    }
    if (link) {
      html += '<a class="mtw-cs__link" href="' + link + '" target="_blank" rel="noopener">Læs mere ' + PIL_SVG + '</a>';
    }
    html += '</div></article>';
    return html;
  }

  function tomBoks(overskrift, tekst, medKnap) {
    return (
      '<div class="mtw-cs__tom">' +
      KAL_SVG +
      '<h2>' + esc(overskrift) + '</h2>' +
      '<p>' + esc(tekst) + '</p>' +
      (medKnap ? '<div><a class="mtw-cs__knap" href="/pages/saelg">Sælg din samling online</a></div>' : '') +
      '</div>'
    );
  }

  function renderTidligere(shows) {
    if (!tidligereSektion || !tidligereEl || !shows || !shows.length) return;
    var sorteret = shows.slice().sort(function (a, b) {
      var da = parseDato(a.start);
      var db = parseDato(b.start);
      return (db ? db.getTime() : 0) - (da ? da.getTime() : 0);
    });
    var html = '';
    var i;
    var show;
    var start;
    var linje2;
    for (i = 0; i < sorteret.length; i++) {
      show = sorteret[i] || {};
      start = parseDato(show.start);
      linje2 = [];
      if (show.by) linje2.push(esc(show.by));
      if (start) linje2.push(MDR[start.getMonth()] + ' ' + start.getFullYear());
      html +=
        '<div class="mtw-cs__tidl"><b>' + esc(show.navn || 'Cardshow') + '</b>' +
        (linje2.length ? '<small>' + linje2.join(' · ') + '</small>' : '') +
        '</div>';
    }
    if (!html) return;
    tidligereEl.innerHTML = html;
    tidligereSektion.hidden = false;
  }

  function render(data) {
    var kommende = (data && data.kommende) || [];
    var tidligere = (data && data.tidligere) || [];

    if (!kommende.length) {
      kommendeEl.innerHTML = tomBoks('Vi planlægger de næste shows', 'Følg med her — kalenderen opdateres, så snart de næste stop er på plads.', false);
    } else {
      var sorteret = kommende.slice().sort(function (a, b) {
        var da = parseDato(a.start);
        var db = parseDato(b.start);
        return (da ? da.getTime() : 0) - (db ? db.getTime() : 0);
      });
      var html = '';
      var i;
      for (i = 0; i < sorteret.length; i++) {
        html += renderShow(sorteret[i] || {}, i === 0);
      }
      kommendeEl.innerHTML = html || tomBoks('Vi planlægger de næste shows', 'Følg med her — kalenderen opdateres, så snart de næste stop er på plads.', false);
    }

    renderTidligere(tidligere);
  }

  fetch('/apps/portal/cardshows', { headers: { 'Accept': 'application/json' } })
    .then(function (res) {
      if (!res.ok) throw new Error('http ' + res.status);
      return res.json();
    })
    .then(render)
    .catch(function () {
      kommendeEl.innerHTML = tomBoks('Kalenderen driller lige nu', 'Prøv igen om lidt — eller sælg din samling online med det samme.', true);
    });
})();
